import regionRepository from '../repositories/regionRepository'

export default function getRegion() {
  return regionRepository()
}
